import type { UserType } from '@/legacy-src/types/UserStateType'

import { getAddressIncludesCounty } from '@/src/utils/getAddressIncludesCounty'

export const getHasCompleteAddress = (user: UserType, showPlaceCategoryInAddress: boolean): boolean => {
  const hasCounty = getAddressIncludesCounty() ? Boolean(user.county) : true

  const hasDefaultAddressFields = Boolean(
    user.firstName &&
      user.lastName &&
      user.street &&
      user.houseNumber &&
      user.city &&
      user.zip &&
      user.residenceCountryCode &&
      hasCounty,
  )

  if (showPlaceCategoryInAddress) {
    return hasDefaultAddressFields && Boolean(user.publicPlaceCategory)
  }

  return hasDefaultAddressFields
}
